import React from 'react';
import Page from '../components/Page';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Modal,
  Input,
  Form,
} from 'reactstrap';
import {
  MdDone,
  MdClear,
  MdCreate,
  MdFilterList,
  MdDateRange,
  MdRemoveRedEye,
  MdDelete,
} from 'react-icons/md';
import axios from 'axios';
import TimesheetLocationDetails from '../components/TimesheetLocationDetails';
import TimesheetForm from '../components/TimesheetForm';
import Moment from 'react-moment';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import Avatar from '../components/Avatar';
import userImage from '../assets/img/users/profile.jpg';

const month = [
  {
    number: '1',
    text: 'Jan',
  },
  {
    number: '2',
    text: 'Feb',
  },
  {
    number: '3',
    text: 'Mar',
  },
  {
    number: '4',
    text: 'Apr',
  },
  {
    number: '5',
    text: 'May',
  },
  {
    number: '6',
    text: 'Jun',
  },
  {
    number: '7',
    text: 'Jul',
  },
  {
    number: '8',
    text: 'Aug',
  },
  {
    number: '9',
    text: 'Sep',
  },
  {
    number: '10',
    text: 'Oct',
  },
  {
    number: '11',
    text: 'Nov',
  },
  {
    number: '12',
    text: 'Dec',
  },
];

class PersonTimesheetPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      createModal: false,
      month: '',
      year: '',
      redirect: false,
      timesheetList: [],
      timesheetId: '',
      mode: '',
      siteList: [],
    };
  }

  toggle = (id, type) => () => {
    return this.setState({
      modal: !this.state.modal,
      timesheetId: id,
      mode: type,
    });
  };

  toggleCreateModal = () => () => {
    return this.setState({
      createModal: !this.state.createModal,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      createModal: false,
    });

    if (reload) {
      window.location.reload();
    }
  };

  changeHandler = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });

    this.getTimesheetList(name, value);
  };

  getTimesheetList = (name, value) => {
    const user = StorageService.getSession('user_info');
    let siteKeys = [];

    for (let s of this.state.siteList) {
      siteKeys.push({ sitekey: s.SiteKey });
    }

    const data = {
      session_key: user.session_key,
      PersonID: this.props.match.params.person,
      SiteKey: siteKeys,
    };

    if (name === 'month') {
      data.Month = value;
      data.Year = this.state.year;
    } else if (name === 'year') {
      data.Month = this.state.month;
      data.Year = value;
    } else {
      data.Month = this.state.month;
      data.Year = this.state.year;
    }

    if (data.Month === '' || data.Year === '') {
      return;
    }
    this.getList(data);
  };

  getList = data => {
    const url = process.env.REACT_APP_API_URL;
    axios
      .post(url + ':3000/v1/person/getTimesheet', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          timesheetList: result.data,
        });
      })
      .catch(error => {
        //alert(error);
      });
  };

  delete = id => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      DataID: id,
      SiteKey: this.state.siteList[0].SiteKey,
    };

    axios
      .post(url + ':3000/v1/person/deleteTimesheet', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.getTimesheetList(null, null);
      })
      .catch(error => {
        //alert(error);
      });
  };

  getCurrentDate(date) {
    let newDate = '';
    if (date === null) {
      newDate = new Date();
    } else {
      newDate = new Date(date);
    }

    let day = newDate.getUTCDate();
    let month = newDate.getUTCMonth() + 1;
    let year = newDate.getUTCFullYear();

    let hour = newDate.getUTCHours();
    let minute = newDate.getUTCMinutes();

    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;

    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  }

  getCurrentMonth() {
    let newDate = new Date();
    let month = newDate.getMonth();
    return month;
  }

  getCurrentYear() {
    let newDate = new Date();
    let year = newDate.getFullYear();
    return year;
  }

  getYears = () => {
    const currentYear = new Date().getFullYear();
    let arr = [];

    for (let i = currentYear; i >= 2010; i--) {
      arr.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }

    return arr;
  };

  getSiteList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
    };

    axios
      .post(url + ':3000/v1/site/get', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          siteList: result.data,
          year: this.getCurrentYear(),
          month: this.getCurrentMonth(),
        });

        let siteKeys = [];

        for (let s of result.data) {
          siteKeys.push({ sitekey: s.SiteKey });
        }

        const data = {
          session_key: user.session_key,
          PersonID: this.props.match.params.person,
          SiteKey: siteKeys,
          Month: this.getCurrentMonth(),
          Year: this.getCurrentYear(),
        };

        this.getList(data);
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    if (StorageService.getSession('selected_org') === null) {
      this.setState({
        redirect: true,
      });
    } else {
      this.getSiteList();
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <Page
        className="PersonTimesheetPage"
        title="Timesheet"
        breadcrumbs={[
          { name: 'Person', active: false, path: '/person' },
          { name: 'Timesheet', active: true, path: '' },
        ]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Row>
                  <Col md={9} className="mb-0">
                    <Form className="AuthForm mb-4">
                      <Row>
                        <Col md={3}>
                          <div className="d-flex align-items-center">
                            <MdDateRange className="ps-input-icon" />
                            <Input
                              type="select"
                              name="month"
                              value={this.state.month}
                              onChange={this.changeHandler}
                            >
                              <option value="">--Select Month--</option>
                              {month.map((item, index) => {
                                return (
                                  <option key={index} value={item.number}>
                                    {item.text}
                                  </option>
                                );
                              })}
                            </Input>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="d-flex align-items-center">
                            <MdDateRange className="ps-input-icon" />
                            <Input
                              type="select"
                              name="year"
                              value={this.state.year}
                              onChange={this.changeHandler}
                            >
                              <option value="">--Select Year--</option>
                              {this.getYears()}
                            </Input>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                  <Col xl={3} lg={3} md={3} className="mb-0 text-right">
                    <Button
                      className="theme-button theme-button-primary"
                      onClick={this.toggleCreateModal()}
                    >
                      Add
                    </Button>
                  </Col>
                </Row>

                <Table responsive bordered className="ps-table">
                  <thead>
                    <tr>
                      <th>Check-In Date/Time</th>
                      <th>Check-In Location</th>
                      <th style={{ width: '1%', whiteSpace: 'nowrap' }}>
                        Image
                      </th>
                      <th style={{ width: '1%', whiteSpace: 'nowrap' }}>
                        Action
                      </th>
                      <th>Check-Out Date/Time</th>
                      <th>Check-Out Location</th>
                      <th style={{ width: '1%', whiteSpace: 'nowrap' }}>
                        Image
                      </th>
                      <th style={{ width: '1%', whiteSpace: 'nowrap' }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.timesheetList.length < 1 && (
                      <tr>
                        <td colSpan="8">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.timesheetList.length > 0 &&
                      this.state.timesheetList.map((item, index) => {
                        return (
                          <tr key={index}>
                            {item.checkin_dt && item.checkin_dt.length > 0 ? (
                              <td>{this.getCurrentDate(item.checkin_dt)}</td>
                            ) : (
                              <td className="td-none"></td>
                            )}

                            {item.checkin_location === '' ? (
                              <td className="td-none"></td>
                            ) : (
                              <td>{item.checkin_location}</td>
                            )}
                            {item.checkin_ref &&
                            (item.checkin_ref !== null &&
                              item.checkin_ref !== '') > 0 ? (
                              <td>
                                <Avatar
                                  className="can-click"
                                  src={
                                    item.checkin_image !== null
                                      ? item.checkin_image
                                      : userImage
                                  }
                                  style={{
                                    width: '25px',
                                    height: '25px',
                                    margin: '0 auto',
                                    display: 'block',
                                    opacity:
                                      item.checkin_image === null ? '.5' : '1',
                                  }}
                                />
                              </td>
                            ) : (
                              <td className="td-none"></td>
                            )}

                            <td>
                              <div className="ps-action-button">
                                {item.checkin_data.length > 0 && (
                                  <Button
                                    className="theme-button-default theme-button-secondary"
                                    onClick={this.toggle(
                                      item.checkin_ref === ''
                                        ? item.checkout_ref
                                        : item.checkin_ref,
                                      'CheckIn',
                                    )}
                                  >
                                    <MdRemoveRedEye />
                                  </Button>
                                )}

                                {item.checkin_ref !== '' && (
                                  <Button
                                    className="theme-button-default theme-button-primary-light"
                                    onClick={() =>
                                      this.delete(item.checkin_ref)
                                    }
                                  >
                                    <MdDelete />
                                  </Button>
                                )}
                              </div>
                            </td>

                            {item.checkout_dt && item.checkout_dt.length > 0 ? (
                              <td>{this.getCurrentDate(item.checkout_dt)}</td>
                            ) : (
                              <td className="td-none"></td>
                            )}

                            {item.checkout_location === '' ? (
                              <td className="td-none"></td>
                            ) : (
                              <td>{item.checkout_location}</td>
                            )}

                            {item.checkout_ref &&
                            (item.checkout_ref !== null &&
                              item.checkout_ref !== '') > 0 ? (
                              <td>
                                <Avatar
                                  className="can-click"
                                  src={
                                    item.checkout_image !== null
                                      ? item.checkout_image
                                      : userImage
                                  }
                                  style={{
                                    width: '25px',
                                    height: '25px',
                                    margin: '0 auto',
                                    display: 'block',
                                    opacity:
                                      item.checkout_image === null ? '.5' : '1',
                                  }}
                                />
                              </td>
                            ) : (
                              <td className="td-none"></td>
                            )}
                            <td>
                              <div className="ps-action-button">
                                {item.checkout_data.length > 0 && (
                                  <Button
                                    className="theme-button-default theme-button-secondary"
                                    onClick={this.toggle(
                                      item.checkout_ref === ''
                                        ? item.checkin_ref
                                        : item.checkout_ref,
                                      'CheckOut',
                                    )}
                                  >
                                    <MdRemoveRedEye />
                                  </Button>
                                )}

                                {item.checkout_ref !== '' && (
                                  <Button
                                    className="theme-button-default theme-button-primary-light"
                                    onClick={() =>
                                      this.delete(item.checkout_ref)
                                    }
                                  >
                                    <MdDelete />
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
          style={{ minWidth: '700px', fontSize: '0.85rem' }}
        >
          <TimesheetLocationDetails
            history={this.props.history}
            onToggleModal={this.toggle}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.createModal}
          toggle={this.toggleCreateModal()}
          className={this.props.className}
          centered
        >
          <TimesheetForm
            history={this.props.history}
            onToggleModal={this.toggleCreateModal}
            data={this.state}
            closeModal={this.closeModal}
            match={this.props.match}
          />
        </Modal>
      </Page>
    );
  }
}
export default PersonTimesheetPage;
